import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { OrgPathway, OrgPathwaysState } from './types';

const initialState: OrgPathwaysState = {
  pathways: [],
  loading: false,
  error: null
};

export const slice = createSlice({
  name: 'orgPathways',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    hasError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    getPathwaysSuccess(state, action: PayloadAction<OrgPathway[]>) {
      state.loading = false;
      state.pathways = action.payload;
    }
  }
});

export default slice.reducer;
